import React, { useMemo } from "react";
import { connect } from "react-redux";
import {
  Div,
  Text1,
  Text3,
  Text5,
  CheckIcon,
  RightIcon
} from "components/Base";
import {
  getWelcomeColor,
  getLoginColor,
  getGroupColor,
  getContactColor,
  getNavigationTitles
} from "Portal/CallForPapersForm/selectors";
import Circle from "ui-kit/Circle";
import { getActiveIndex } from "../selectors";

const decorate = connect(state => ({
  welcomeColor: getWelcomeColor(state),
  loginColor: getLoginColor(state),
  groupColor: getGroupColor(state),
  contactColor: getContactColor(state),
  activeIndex: getActiveIndex(state),
  stepsNames: getNavigationTitles(state)
}));

const Steps = ({
  welcomeColor,
  loginColor,
  groupColor,
  contactColor,
  activeIndex,
  mobile,
  stepsNames = []
}) => {
  const Text = useMemo(() => (mobile ? Text3 : Text5), [mobile]);
  const separatorArrow = useMemo(
    () =>
      mobile ? null : (
        <RightIcon tabIndex={-1} color="neutral5" size={16} mx={2} />
      ),
    [mobile]
  );
  const colorMapping = useMemo(
    () => [welcomeColor, loginColor, groupColor, contactColor],
    [welcomeColor, loginColor, groupColor, contactColor]
  );
  const steps = useMemo(
    () =>
      stepsNames.map((stepLabel, index) => (
        <>
          {index !== 0 ? separatorArrow : null}
          <Div
            key={`step-${stepLabel}`}
            display="row.flex-start.center"
            tabIndex={0}
            aria-label={`${stepLabel} Step`}
          >
            {activeIndex === index ? (
              <Div
                bg="white"
                shadow={2}
                width={16}
                height={16}
                style={{ borderRadius: 8 }}
                display="row.center.center"
              >
                <Circle size={10} bg="indigo7" />
              </Div>
            ) : (
              <Circle size={16} bg="gray7">
                {index === 0 || activeIndex > index ? (
                  <CheckIcon size={10} color="white" />
                ) : (
                  <Text1 color="white">{index + 1}</Text1>
                )}
              </Circle>
            )}
            <Text
              ml={2}
              bold
              color={colorMapping[index]}
              style={{ fontSize: "20px" }}
              textAlign={"center"}
            >
              {stepLabel}
            </Text>
          </Div>
        </>
      )),
    [activeIndex]
  );

  return (
    <Div
      display={
        mobile ? "column.flex-start.flex-start" : "row.flex-start.center"
      }
      height={mobile ? "inherit" : 80}
      mt={mobile ? 4 : 0}
      mb={mobile ? 6 : 4}
      tabIndex={0}
    >
      {steps}
    </Div>
  );
};

export default decorate(Steps);
